<template>
  <div class="dropshipping-wrapper">
    <div class="wholesale">
      Wholesale
    </div>
    <div class="dropshipping">
      <Button
        class="dropshipping__button"
        @click="onClick"
        :class="{ 'dropshipping__button--bounded': hasBoundStore }"
        :loading="loading"
        :block="false"
      >
        <div
          v-if="hasBoundStore"
          class="dropshipping__bounded"
        >
          <Icon name="shop" />
          <Icon
            class="dropshipping__bounded--right"
            name="right-l"
          />
        </div>
        <Icon
          v-else
          name="shop"
          class="dropshipping__unbound"
        />
        {{ hasBoundStore ? 'Go Dropshipping' : 'Start Dropshipping' }}
        <img
          v-if="hasBoundStore"
          class="dropshipping__badge"
          src="@/assets/offer/free-sample.png"
          alt="free sample"
        >
      </Button>
    </div>
  </div>
</template>

<script setup>
import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { useDropshipping } from '@/components/Dropshipping'

defineProps({
  moq: Number
})

const { loading, hasBoundStore } = useDropshipping()
const onClick = () => {
  window.location.href = import.meta.env.VITE_QUOTE_URL
}
</script>

<style lang="less" scoped>
.dropshipping-wrapper {
  box-sizing: content-box;
  display: flex;
  height: 48px;
  padding: 12px 12px 0;
  overflow: hidden;

  .wholesale {
    position: relative;
    width: 47.154%;
    border-radius: 8px 8px 0 0;
    border: 1px solid #EBF1F5;
    border-bottom: none;
    color: #232323;
    font-size: 14px;
    font-family: mon-600;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 4px 0 6px #14141410;
  }
  .dropshipping {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #EBF1F5;

    &__button {
      position: relative;
      gap: 4px;
      padding: 7px 12px 7px 8px;
      height: auto;
      color: #232323;
      background-color: #F8F8F8;
      border: 1px solid #DFDFDF;
      font-size: 12px;

      &--bounded {
        background-color: white;
        border-color: currentColor;
      }
    }

    &__unbound {
      flex-shrink: 0;
      box-sizing: content-box;
      font-size: 16px;
      padding: 2px;
      border-radius: 100%;
      color: white;
      background-color: #1B3E9C;
    }

    &__bounded {
      position: relative;
      font-size: 20px;

      > svg {
        display: block;
      }

      &--right {
        position: absolute;
        right: -1px;
        bottom: 0;
        font-size: 6px;
        padding: 2px;
        box-sizing: content-box;
        background-color: #1B3E9C;
        border: 1.5px solid #FFFFFF;
        border-radius: 100%;
        color: white;
      }
    }

    &__badge {
      position: absolute;
      left: 50%;
      top: -12px;
      transform: translate(-50%, 0);
      height: 19px;
      animation: shake 1.5s infinite;
    }
  }

  @keyframes shake {
    0% { transform: translateX(-50%); }
    10% { transform: translateX(-50% - 2px); }
    25% { transform: translateX(-50% + 2px); }
    50% { transform: translateX(-50% - 2px); }
    65% { transform: translateX(-50% + 2px); }
    80% { transform: translateX(-50%); }
    100% { transform: translateX(-50%); }
  }
}
</style>
